export type QueryShape = 'question' | 'lookup';

// "will" and "may" are left out: they are also first names.
const QUESTION_WORDS = new Set([
  'who',
  'whom',
  'whose',
  'what',
  'when',
  'where',
  'why',
  'how',
  'which',
  'can',
  'could',
  'should',
  'would',
  'is',
  'are',
  'do',
  'does',
  'did',
]);

const REQUEST_WORDS = new Set([
  'show',
  'list',
  'summarize',
  'summarise',
  'explain',
  'compare',
  'tell',
  'help',
]);

// Long enough that it is rarely a person, team or workstream name.
const QUESTION_WORD_COUNT = 5;

/**
 * Whether a search query reads like something to ask rather than a name to
 * look up. "Kyle" and "Core Platform" are lookups; "who owns billing",
 * "my manager" and "perks allowance?" are questions.
 */
export const isQuestionShaped = (query: string): boolean => {
  const trimmed = query.trim();
  if (!/[\p{L}\p{N}]/u.test(trimmed)) {
    return false;
  }
  if (trimmed.includes('?')) {
    return true;
  }

  const words = trimmed.toLowerCase().split(/\s+/);
  if (words.length >= QUESTION_WORD_COUNT) {
    return true;
  }
  if (words.length < 2) {
    return false;
  }

  const first = words[0].replace(/['’]s$/, '');
  return first === 'my' || QUESTION_WORDS.has(first) || REQUEST_WORDS.has(first);
};

export const queryShape = (query: string): QueryShape =>
  isQuestionShaped(query) ? 'question' : 'lookup';
